import { makeStyles } from '@material-ui/core';
import logo from './logo.png';

const useStyles = makeStyles({
  img: {
    display: 'block',
    height: 72,
    width: 'auto',
    maxWidth: 168,
    objectFit: 'contain',
  },
});

export const LogoFull = () => {
  const classes = useStyles();
  return <img className={classes.img} src={logo} alt="CHI Backstage" />;
};
